// src/components/Blocks/TCEvents/Schema.js

const TCEventsSchema = {
  title: 'TC Events',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title', 'displayMode', 'maxEvents'],
    },
    {
      id: 'display',
      title: 'Display Options',
      fields: [
        'showEventType',
        'showSpeaker',
        'showDateTime',
        'showDescription',
      ],
    },
  ],
  properties: {
    title: {
      title: 'Block Title',
      type: 'string',
      description: 'Optional title for the events block',
    },
    displayMode: {
      title: 'Display Mode',
      type: 'string',
      default: 'accordion',
      enum: ['accordion', 'simple'],
      enumNames: ['Accordion Format', 'Simple List'],
      description: 'Display Mode : accordion or List',
    },
    maxEvents: {
      title: 'Maximum Events to Display',
      type: 'number',
      default: 5,
      minimum: 1,
      maximum: 10,
      description: 'Number of events to show (1-10)',
    },
    showEventType: {
      title: 'Show Event Type',
      type: 'boolean',
      default: true,
    },
    showSpeaker: {
      title: 'Show Speaker Details',
      type: 'boolean',
      default: true,
    },
    showDateTime: {
      title: 'Show Date and Time',
      type: 'boolean',
      default: true,
    },
    showDescription: {
      title: 'Show Event Description',
      type: 'boolean',
      default: true,
      description: 'Only applies to accordion mode',
    },
  },
  required: [],
};

export default TCEventsSchema;
